var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScorpio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34.643 33.315-1.048 1.572L36.5 36.84c-4.19-.095-7.048-2.286-7.238-3.525-.143-.524 0-26.917 0-26.917A6.383 6.383 0 0 0 22.88.014a6.382 6.382 0 0 0-5.429 3.05C16.31 1.253 14.31.013 12.024.013a6.34 6.34 0 0 0-5.476 3.097A6.385 6.385 0 0 0 1.31.348c-.286 0-.524 0-.81.048.048.666.095 1.381.19 2.048.19-.048.43-.048.62-.048 2.38 0 4.333 1.954 4.333 4.336V31.219h2.095V6.399c0-2.383 1.952-4.336 4.333-4.336 2.381 0 4.334 1.953 4.334 4.335v24.869h2.238V6.35c0-2.382 1.952-4.336 4.333-4.336 2.381 0 4.334 1.954 4.334 4.336v26.297s-.572 5.384 9.142 5.955l-2.714 1.81 1.048 1.573 5.714-3.811v-1.096l-5.857-3.764zm3.047 4.383v-.095l.048.047-.047.048z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScorpio);
export default __webpack_public_path__ + "static/media/scorpio.9920568352fef70f014004154694b09e.svg";
export { ForwardRef as ReactComponent };